import React from 'react';
import TitleSection from "../../molecules/title-section";
import Button from "../../atoms/button/button";
import { ReferenciaContenido } from '../../../interfaces/ReferenciaContenido';
import "./RecommendationsSpecialPrograms.scss";
import { withPrefix } from 'gatsby';

const RecommendationsSpecialPrograms = (props: ReferenciaContenido) => {
    return (
        <div className="o-recommendations-special-programs">
            <TitleSection title={props.tituloGeneral} />

            <div className="o-recommendations-special-programs__items">
                {props.referenciaPlantillaContenido.map((program, index) => {
                    const convocatoriaClase = program.tipoTitulo === 'Convocatoria abierta' 
                        ? 'convocatoria-abierta' 
                        : 'convocatoria-cerrada';

                    return (
                        <a key={index} href={program.redireccionBoton} className={`o-recommendations-special-programs__item ${convocatoriaClase}`}>
                            <div className="o-recommendations-special-programs__item__icon">
                                <img 
                                    src={program.imagenPrincipal[0].file.url} 
                                    alt={program.imagenPrincipal[0].file.fileName} 
                                />
                            </div>
                            <div className="o-recommendations-special-programs__item__content">
                                <div className="convocatoria-header">
                                    <span>{program.tituloDescripcion}</span>
                                </div>
                                <p>{program.descripcion.json.content[0].content[0].value}</p>
                                <Button
                                    type="link"
                                    classname={`conoce-mas-button ${convocatoriaClase}`}
                                    text={program.tituloBoton}
                                    href={withPrefix(props.redireccionBoton)}
                                    isDisabled={false}
                                />
                            </div>
                        </a>
                    );
                })}
            </div>
        </div>
    );
}

export default RecommendationsSpecialPrograms;
